export const EVENT_LOG_TYPES = {
    PRODUCT_ADD: "product_add",
    PRODUCT_UPDATE: "product_update",
    PRODUCT_STATUS_UPDATE: "product_status_update",
    PRODUCT_DELETE: "product_delete",
    PRODUCT_IMAGE_ADD_EDIT: "product_image_add_edit",
    ORDER_EDIT: "order_edit",
    PRODUCT_VIDEO_ADD_UPDATE: "product_video_add_update",
    COUPON_CREATE: "coupon_create",
    COUPON_UPDATE: "coupon_update",
    COUPON_DELETE: "coupon_delete",
    BANNER_CREATE: "banner_create",
    BANNER_UPDATE: "banner_update",
    BANNER_DELETE: "banner_delete",
    BANNER_REORDER: "banner_reorder",
    NOTIFICATION_CREATE: "notification_create",
    STORY_CREATE: "story_create",
    STORY_UPDATE: "story_update",
    STORY_DELETE: "story_delete",
    STORY_REORDER: "story_reorder",
    STORY_COLLECTION_ADD: "story_collection_add",
    STORY_COLLECTION_UPDATE: "story_collection_update",
    STORY_COLLECTION_DELETE: "story_collection_delete",
    WHATSAPP_CREATE: "whatsapp_create",
    WHATSAPP_CHAT_DELETE: "whatsapp_chat_delete",
    CATEGORY_CREATE: "category_create",
    CATEGORY_UPDATE: "category_update",
    CATEGORY_DELETE: "category_delete",
    SUB_CATEGORY_CREATE: "sub_category_create",
    SUB_CATEGORY_UPDATE: "sub_category_update",
    SUB_CATEGORY_DELETE: "sub_category_delete",
    CATEGORY_REORDER: "category_reorder",
    USER_ADDRESS_EDIT_REQUEST: "user_address_edit_request",
    GENERAL_SUBCATEGORY_CREATE: "general_subcategory_create",
    REEL_VIDEO_CREATE: "reel_video_create",
    REEL_VIDEO_UPDATE: "reel_video_update",
    REEL_VIDEO_REORDER: "reel_video_reorder",
    REEL_VIDEO_DELETE: "reel_video_delete",
    ADMIN_CREATE: "admin_create",
    ADMIN_UPDATE: "admin_update",
    ADMIN_DELETE: "admin_delete",
    EXPRESS_SETTINGS_UPDATE: "express_settings_update",
    STAFF_CREATE: "staff_create",
    STAFF_UPDATE: "staff_update",
    STAFF_DELETE: "staff_delete",
    DISPATCH_DELETE: "dispatch_delete",
    STAFF_ASSIGN: "staff_assign",
    GENERAL_SETTINGS_UPDATE: "settings_update",
    SPIN_WHEEL_SETTINGS_UPDATE: "spin_wheel_settings_update",
}